/**
 * Local copy of the canonical `preloadDefaultDetails()` contract.
 *
 * DEVIATION from the cross-repo MUST:
 *   The contract-pinning protocol asks consumers to import
 *   `preloadDefaultDetails` from
 *   `monolith-typescript/src/lib/classes/Property.class`. Admin cannot do
 *   that today for two reasons:
 *
 *     1. The canonical file lives in the integration branch
 *        `feat/property-create-admin` of the `monolith-typescript`
 *        sibling worktree, not in `main`. The sibling worktree this admin
 *        worktree can see (`wt-monolith-typescript-int`) has the function,
 *        but main does not. Wiring admin's tsconfig paths to a non-main
 *        branch would couple admin's build to a sibling worktree that may
 *        not exist on a fresh checkout.
 *
 *     2. The canonical file imports `mongodb` and several other classes
 *        that are not part of admin's bundle. Importing it directly would
 *        inflate admin's bundle by tens of MB.
 *
 *   To keep the contract testable and admin's bundle clean, we keep a
 *   verbatim copy of the function here. The string values used for
 *   `type` and `size` mirror the canonical enums
 *   (`PropertyDetailsType.{Directions,Contact,Info}` and
 *   `PropertyDetailsSize.Small`) and are type-cast through admin's own
 *   `PropertyDetails` interface so the result is assignable to admin's
 *   `Property.content[lang].details`. Keep the body in sync with
 *   `monolith-typescript/src/lib/classes/Property.class.ts` on branch
 *   `feat/property-create-admin` (PR #136). The contract test
 *   `monolith-typescript/src/lib/classes/__tests__/preloadDefaultDetails.test.ts`
 *   pins the shape; if the canonical function changes, update this copy
 *   in the same commit.
 *
 * See: getlst/getlost-web#53, getlst/getlost-admin#105,
 *      getlst/monolith-typescript#136.
 */
import { PropertyDetailsSize, PropertyDetailsType, type PropertyDetails } from '../../interfaces/property';

// The six canonical detail blocks every new property starts with. Mirrors
// the output of `preloadDefaultDetails()` from monolith-typescript and the
// shared fixture in
// monolith-typescript/src/lib/classes/__tests__/fixtures/preload-default-details.fixture.ts.
// Order, types, and sizes are pinned by the contract tests; do not change
// here without updating the canonical source and the fixture.
export function preloadDefaultDetails(): PropertyDetails[] {
    return [
        {
            name: 'Directions',
            type: PropertyDetailsType.Directions,
            size: PropertyDetailsSize.Small,
            contents: '',
            order: 0
        },
        {
            name: 'Contact {Name}',
            type: PropertyDetailsType.Contact,
            size: PropertyDetailsSize.Small,
            contents: '',
            order: 1
        },
        {
            name: 'Check In',
            type: PropertyDetailsType.Info,
            size: PropertyDetailsSize.Small,
            contents: '',
            order: 2
        },
        {
            name: 'Check Out',
            type: PropertyDetailsType.Info,
            size: PropertyDetailsSize.Small,
            contents: '',
            order: 3
        },
        {
            name: 'Wifi',
            type: PropertyDetailsType.Info,
            size: PropertyDetailsSize.Small,
            contents: '',
            order: 4
        },
        {
            name: 'Emergency',
            type: PropertyDetailsType.Info,
            size: PropertyDetailsSize.Small,
            contents: '',
            order: 5
        }
    ];
}
